import { Button, Stack } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "./context";

// ----------------------------------------------------------------------

export const DeleteApp = () => {
	const { actions } = useContext(Context);
	const { translate } = useLocales();
	return (
		<Stack sx={{ maxWidth: 800, flexDirection: "row", justifyContent: "flex-end" }}>
			<Button color='error' onClick={actions.showDeleteAppDialog}>
				{translate("app_settings.delete_app")}
			</Button>
		</Stack>
	);
};

export default DeleteApp;
